import React from "react"

import { EnergyProjectMarker, EnergyRadiusMarker } from "./EnergyView"

import ProjectMap from "@dashboard/ProjectMap"
import { MapView } from "@common/module/EcosuiteView"
import EnergyViewControls from "./EnergyViewControls"

class ProjectEnergyOverView extends MapView {
  renderViewControls() {
    return (
      <EnergyViewControls
        restrictions={this.props.restrictions}
        groups={this.props.groups}
        rangeName={this.props.rangeName}
        customRange={this.props.customRange}
        project={this.props.project}
        projects={this.props.projects}
        viewControls={this.getEnergyViewControls()}
      />
    )
  }

  getEnergyViewControls() {
    return null
  }

  getDefaultCenter(project) {
    return { lat: project.lat, lng: project.long }
  }

  //Because changing project does not cause re-render, we can force it by setting a key
  renderMapView() {
    return (
      <ProjectMap
        key={new Date().getTime()}
        markers={this.getMapMarkers()}
        defaultZoom={12}
        defaultCenter={this.getDefaultCenter(this.props.project)}
      />
    )
  }

  getMapMarkers() {
    let siteMarkers =
      this.props.project == null
        ? []
        : Object.values(this.props.project.sites).map((site) => {
            let siteStatus = this.getSiteStatus(site.code)
            let siteReading = this.getSiteReading(site.code)

            return site.lat && site.long ? (
              <React.Fragment key={`site-${site.code}`}>
                <EnergyProjectMarker
                  type="Site"
                  project={site}
                  projectReading={siteReading}
                  projectStatus={siteStatus}
                  showGeneration={this.props.showGeneration}
                  showConsumption={this.props.showConsumption}
                  showStorage={this.props.showStorage}
                />
                <EnergyRadiusMarker
                  project={site}
                  projectReading={siteReading}
                  readings={this.props.readings}
                  projectStatus={siteStatus}
                  showGeneration={this.props.showGeneration}
                  showConsumption={this.props.showConsumption}
                  showStorage={this.props.showStorage}
                />
              </React.Fragment>
            ) : null
          })

    let project = this.props.project
    let projectMarker =
      project.lat && project.long ? (
        <React.Fragment key={project.code}>
          <EnergyProjectMarker
            project={project}
            projectReading={this.props.readings}
            projectStatus={this.props.projectStatus}
            showGeneration={this.props.showGeneration}
            showConsumption={this.props.showConsumption}
            showStorage={this.props.showStorage}
          />
        </React.Fragment>
      ) : null

    return [projectMarker, ...siteMarkers]
  }

  getSiteStatus(siteId) {
    if (this.props.projectStatus) {
      return this.props.projectStatus.sites[siteId]
    }
    return null
  }

  getSiteReading(siteId) {
    if (this.props.readings) {
      return this.props.readings.sites[siteId]
    }
    return null
  }
}

export default ProjectEnergyOverView
